import React from 'react';

const BOLD_PHRASE = 'Dallas Parks and Recreation';
const BOLD_LINE_PREFIXES = [
  'Dates:',
  'Location:',
  'Swim Lesson:',
  'Cost:',
  'Participants:'
];

function renderLine(line) {
  if (line.startsWith('Time:')) {
    const times = line.slice('Time:'.length).trim();
    return (
      <>
        <strong>Time:</strong> {times}
      </>
    );
  }

  const matchedPrefix = BOLD_LINE_PREFIXES.find((prefix) => line.startsWith(prefix));
  if (!matchedPrefix) return line;

  return (
    <>
      <strong>{matchedPrefix}</strong>
      {line.slice(matchedPrefix.length)}
    </>
  );
}

function renderWithLineBreaks(text) {
  return text.split('\n').map((line, index, lines) => (
    <React.Fragment key={index}>
      {renderLine(line)}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
}

export function FormattedEventDescription({ text }) {
  if (!text) return null;
  if (!text.includes(BOLD_PHRASE)) {
    return <>{renderWithLineBreaks(text)}</>;
  }

  const [before, after] = text.split(BOLD_PHRASE);
  return (
    <>
      {renderWithLineBreaks(before)}
      <strong>{BOLD_PHRASE}</strong>
      {renderWithLineBreaks(after)}
    </>
  );
}
